import { render } from "./UserEnteredText.vue?vue&type=template&id=f7c4c6ae"
import script from "./UserEnteredText.vue?vue&type=script&lang=js"
export * from "./UserEnteredText.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__